import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAtom } from 'jotai';
import { scrollPositionsAtom } from '../Services/store/atoms';

function ScrollToTop() {
  const { pathname } = useLocation();
  const history = useHistory();
  const [scrollPositions, setScrollPositions] = useAtom(scrollPositionsAtom);

  useEffect(() => {
    if (pathname.includes('/profileModal/')) return;

    const saved = scrollPositions[pathname];
    if (saved > 0) {
      window.scrollTo(0, saved);
    } else if (history.action !== 'POP') {
      window.scrollTo(0, 0);
    }

    return () => {
      if (pathname.includes('/profileModal/')) return;
      setScrollPositions(prev => ({
        ...prev,
        [pathname]: window.scrollY,
      }));
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop;
